import { render, staticRenderFns } from "./connections.vue?vue&type=template&id=579f8439&scoped=true"
import script from "./connections.vue?vue&type=script&lang=js"
export * from "./connections.vue?vue&type=script&lang=js"
import style0 from "./connections.vue?vue&type=style&index=0&id=579f8439&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579f8439",
  null
  
)

export default component.exports